import src from "IMAGE";
export default { src, width: 129, height: 37, blurWidth: 0, blurHeight: 0};
